import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { User, LogOut, ChevronDown } from 'lucide-react';
import { useAuth, useTooltip } from '@app/providers';
import UserAvatar, { getFrameType, createAnimator } from '@entities/user/ui/UserAvatar';
import './UserMenu.css';

const UserMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const avatarStandaloneRef = useRef(null); // Реф для анимации рамки
  const animationRef = useRef(null);
  const { user, logout } = useAuth();
  const { showTooltip, hideTooltip } = useTooltip();
  const navigate = useNavigate();

  // Логика закрытия меню
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // ВОЗВРАЩАЕМ АНИМАЦИЮ РАМКИ
  useEffect(() => {
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
      animationRef.current = null;
    }

    if (avatarStandaloneRef.current) {
      avatarStandaloneRef.current.style.boxShadow = '';
      avatarStandaloneRef.current.style.borderColor = '';
    }

    if (!user || !avatarStandaloneRef.current) return;

    const frameType = getFrameType(user);
    if (!frameType) return;

    const startAnimation = createAnimator(avatarStandaloneRef, animationRef);
    startAnimation(frameType);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
        animationRef.current = null;
      }
    };
  }, [user?.id, user?.is_superuser, user?.is_staff, user?.is_librarian, user?.is_donor]);

  if (!user) return null;

  const handleLogout = () => {
    setIsOpen(false);
    logout();
    navigate('/');
  };

  return (
    <div ref={menuRef} className="user-menu-wrapper-new">
      <div className="user-menu-standalone">
        {/* ЛЕВАЯ ЧАСТЬ: КНОПКА С ИМЕНЕМ */}
        <button
          className={`user-nav-btn-split ${isOpen ? 'active' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
          onMouseEnter={() => showTooltip('АККАУНТ', user.display_name || user.username, 'Нажмите для управления')}
          onMouseLeave={hideTooltip}
        >
          <span className="user-nav-name">{user.display_name || user.username}</span>
          <ChevronDown size={14} className={`user-nav-arrow ${isOpen ? 'open' : ''}`} />
        </button>

        {/* ПРАВАЯ ЧАСТЬ: АВАТАР С АНИМАЦИЕЙ РАМКИ */}
        <div 
          ref={avatarStandaloneRef}
          className="user-nav-avatar-standalone"
          onClick={() => setIsOpen(!isOpen)}
          style={{ cursor: 'pointer' }}
        >
          <UserAvatar user={user} size="large" withFrame={true} />
        </div>
      </div>

      {isOpen && (
        <div className="user-dropdown visible">
          <ul className="user-menu-list">
            <li>
              <Link to="/profile" className="user-menu-item" onClick={() => setIsOpen(false)}>
                <User size={16} /> <span>ПРОФИЛЬ</span>
              </Link>
            </li>
            <li className="user-menu-divider">
              <button onClick={handleLogout} className="user-menu-item logout-btn">
                <LogOut size={16} /> <span>ВЫЙТИ</span>
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
